import { Ruleset } from "@rosette/ts/src/business/game/Ruleset.js";
import finkelBoardIcon from "@rosette/assets/src/buttons/board_finkel.svg";
import mastersBoardIcon from "@rosette/assets/src/buttons/board_masters.svg";
import blitzBoardIcon from "@rosette/assets/src/buttons/board_blitz.svg";
import customBoardIcon from "@rosette/assets/src/buttons/board_custom.svg";
import type { StaticImageData } from "next/image";


export function getRulesetIcon(ruleset: Ruleset | null): StaticImageData {
    if (ruleset === null)
        return customBoardIcon;

    if (ruleset === Ruleset.FINKEL)
        return finkelBoardIcon;
    if (ruleset === Ruleset.MASTERS || ruleset === Ruleset.OLD_MASTERS)
        return mastersBoardIcon;
    if (ruleset === Ruleset.BLITZ)
        return blitzBoardIcon;

    return customBoardIcon;
}
